import { ReferenceType } from '@modules/client';

const getApiReferenceTypeLabel = (refType: ReferenceType) => {
  // display label on reference type
  switch (refType) {
    case ReferenceType.CLASS:
      return 'Class';
    case ReferenceType.DATATYPE:
      return 'Data Type';
    case ReferenceType.ENUM:
      return 'Enum';
    case ReferenceType.LIBRARY:
      return 'Library';
    case ReferenceType.GLOBAL:
      return 'Global';
    default:
      return undefined;
  }
};

export default getApiReferenceTypeLabel;
